export default {
  wrapper: {
    base: {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      zIndex: 100,
      variant: 'spark.base.wrapper'
    },
    variants: {
      grey: {
        variant: 'spark.element.overlay.wrapper.base'
      },
      white: {
        variant: 'spark.element.overlay.wrapper.base'
      }
    }
  },
  overlay: {
    base: {
      position: 'absolute',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
      backgroundColor: 'grey-100',
      opacity: 0.6,
      transition: 'opacity 300ms ease',
      zIndex: -1
    },
    variants: {
      grey: {
        variant: 'spark.element.overlay.overlay.base'
      },
      white: {
        variant: 'spark.element.overlay.overlay.base',
        backgroundColor: 'white',
        opacity: 1
      }
    }
  }
};